/* eslint-disable no-useless-escape */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';

import { getQlikApp } from '../utils/qlik';
import { getQlikAppId } from '../state/selectors/getQlikAppId';
import { addBreadcrumbs, removeBreadcrumb } from '../state/breadcrumbs';
import QlikBreadcrumb from './QlikBreadcrumb';
import { BREADCRUMB_BLACKLIST } from '../constants/blacklist';

class QlikBreadcrumbs extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.app = null;
    this.selectionState = null;
  }

  async componentDidMount() {
    const { qlikAppId } = this.props;
    this.app = await getQlikApp(qlikAppId);

    this.selectionState = this.app.selectionState();
    this.selectionState.OnData.bind(this.handleSelectionStateChange);
  }

  componentWillUnmount() {
    this.selectionState.OnData.unbind(this.handleSelectionStateChange);
  }

  async handleRemoveBreadcrumb(breadcrumb) {
    const { removeBreadcrumb } = this.props;
    await this.app.field(breadcrumb).clear();
    removeBreadcrumb(breadcrumb);
  }

  handleSelectionStateChange() {
    const { defaultSelections, addBreadcrumbs, breadcrumbs } = this.props;
    const defaultSelectionsFields = Object.keys(defaultSelections);

    const newBreadcrumbs = this.selectionState.selections
      .map(({ fieldName, qSelected }) => {
        if (
          !defaultSelectionsFields.includes(fieldName)
          && !BREADCRUMB_BLACKLIST.includes(fieldName)
        ) {
          const isIrregular = fieldName.match(/.*?(\'.*?\')/g);

          if (!isIrregular) {
            return {
              fieldName,
              selectionValue: fieldName,
              printValue: qSelected.trim(),
            };
          }

          const includes = isIrregular[0].indexOf("'");

          if (includes > -1) {
            const start = includes + 1;
            const end = isIrregular[0].lastIndexOf("'");
            return {
              fieldName,
              selectionValue: isIrregular[0].slice(start, end),
              printValue: qSelected.trim(),
            };
          }
        }
        return null;
      })
      .filter(el => el != null);

    if (breadcrumbs.length !== newBreadcrumbs.length) {
      addBreadcrumbs(newBreadcrumbs);
    }
  }

  render() {
    const { breadcrumbs } = this.props;
    return breadcrumbs.map(({ selectionValue, fieldName }) => (
      <QlikBreadcrumb
        key={selectionValue}
        text={selectionValue}
        action={this.handleRemoveBreadcrumb.bind(null, fieldName)}
      />
    ));
  }
}

QlikBreadcrumbs.propTypes = {
  qlikAppId: PropTypes.string.isRequired, // supplied from Redux
  breadcrumbs: PropTypes.array.isRequired, // supplied from Redux
  defaultSelections: PropTypes.object.isRequired, // supplied from Redux
  addBreadcrumbs: PropTypes.func.isRequired, // supplied from Redux
  removeBreadcrumb: PropTypes.func.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  qlikAppId: getQlikAppId(state),
  breadcrumbs: state.breadcrumbs,
  defaultSelections: state.defaultSelections,
});

const mapDispatchToProps = {
  addBreadcrumbs,
  removeBreadcrumb,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QlikBreadcrumbs);
